import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';

/**
 * Header component for client portal that displays the project header with navigation
 */
function ProjectHeader({ project, loading, error }) {
  if (loading || error || !project) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-800 shadow">
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-white">
              Project Portal
            </h1>
            
            <div className="ml-6 bg-blue-500 bg-opacity-20 rounded-lg px-3 py-1 flex items-center">
              <span className="text-blue-100 text-sm font-medium">
                {project.client_name || 'Client'} Portal
              </span>
            </div>
            
            {project.has_pending_missing_items && (
              <div className="ml-4 flex items-center">
                <div className="bg-red-600 text-white rounded-full px-2 py-1 text-xs font-bold flex items-center animate-pulse">
                  <ExclamationCircleIcon className="h-4 w-4 mr-1" />
                  <span>{project.pending_missing_items_count} Required {project.pending_missing_items_count === 1 ? 'Item' : 'Items'}</span>
                </div>
              </div>
            )}
          </div>
          
          <div>
            <a 
              href={`mailto:support@example.com?subject=Help with project: ${project.name}`}
              className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-blue-800 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Need Help?
            </a>
          </div>
        </div>
        
        <div className="mt-1">
          <p className="text-sm text-blue-100">
            This portal provides access to your project details, timeline, and allows you to provide feedback.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProjectHeader; 